export const capitalizeWord = (word: string) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`
